export const dishKeys = {
  all: ['dishes'] as const,
  lists: () => [...dishKeys.all, 'list'] as const,
  list: (query?: string) => [...dishKeys.lists(), query ?? ''] as const,
  details: () => [...dishKeys.all, 'detail'] as const,
  detail: (id: number) => [...dishKeys.details(), id] as const,
};
